export { DemoPreviewOnRegionComponent } from './demo-preview-on-region.component';


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/demo-preview-on-region/index.ts